import React from 'react';
import {Typeahead} from '../components/typeahead';
import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {highlightResults} from './searchinput';
import {useDebounce} from './debounce';

export const toGqlVariables = (obj) => {
    const vars = [];
    const stringValues = ['startsWith']; // can add more keys in future if they have String as values
    Object.entries(obj).forEach(([key, val]) => {
        if (stringValues.includes(key)) {
            vars.push(`${key}: "${val}"`);
        } else {
            vars.push(`${key}: ${val}`);
        }
    });
    const varsBracket = vars.length ? `(${vars.join(', ')})` : '';
    return varsBracket;
};

export const useRecentResults = (search) => {
    const filteredSearch =
        search && search.replace(/\\/g, '').replace(/\"/g, '');

    const queryArguments = {
        useHistory: true,
        startsWith: filteredSearch || ' ',
        limit: 8
    };

    const GET_SUGGESTIONS = gql`
        query {
            typeAheadSuggestions${toGqlVariables(queryArguments)} {
                gaiaId
                term
    			type
                matchType
    			uuid
            }
        }
    `;
    const {data, loading} = useQuery(GET_SUGGESTIONS, {
        fetchPolicy: 'no-cache'
    });

    return {
        data,
        loading
    };
};

export const selectHistoryfromEGTA = (suggestions) => {
    let results = [];
    for (let i = 0; i < suggestions.length; i++) {
        if (
            suggestions[i].matchType === 'RECENT_HISTORY' &&
            results.length < 2
        ) {
            results.push({
                recentlyviewed: true,
                ...suggestions[i]
            });
        }
    }
    return results;
};

export const getRecentlyViewed = (recentResults) => {
    return recentResults.loading || !recentResults.data
        ? []
        : selectHistoryfromEGTA(recentResults.data.typeAheadSuggestions);
};

export const getResults = (
    recentResults,
    resultWithoutHistory,
    resultWithHistory
) => {
    return recentResults.loading ? resultWithoutHistory : resultWithHistory;
};

export const filterSimilarResults = (resultWithoutHistory, historyResults) => {
    let recentResultsGaiaID = [];

    historyResults.forEach((value) => {
        recentResultsGaiaID.push(value.gaiaId);
    });

    let results = resultWithoutHistory.filter(
        (item) => !recentResultsGaiaID.includes(item.gaiaId)
    );

    const finalfilteredResult = historyResults.concat(results);
    return finalfilteredResult;
};

export const getResultsWithHistory = (results, recentlyViewedResults) => {
    return results
        ? filterSimilarResults(results, recentlyViewedResults)
        : recentlyViewedResults;
};

export const getUnhighlightedRecentResults = (
    recentResults,
    defaultResults
) => {
    return recentResults.loading ? defaultResults : recentResults;
};

const FunctionalContainer = (props) => {
    const defaultResults = {loading: true, data: []};
    const debouncedSearch = useDebounce(props.search);
    const recentResults = useRecentResults(debouncedSearch);
    const results = getUnhighlightedRecentResults(
        recentResults,
        defaultResults
    );
    let newProps = {...props};

    const resultWithoutHistory = props.results;
    const highlightedRecentResults = highlightResults(
        props.search || ' ',
        getRecentlyViewed(results)
    );
    const resultWithHistory = getResultsWithHistory(
        resultWithoutHistory,
        highlightedRecentResults
    );

    newProps.results = getResults(
        recentResults,
        resultWithoutHistory,
        resultWithHistory
    );
    return <Typeahead {...newProps} />;
};

export default FunctionalContainer;
